import { Box, Typography } from "@mui/material";
import { iDetailListItemProps } from "../../../../types/contentType";
import "./corporateEventDetailListItem.scss";

const CorporateEventDetailListItem = ({
	title,
	value,
	renderValue,
	detailListItemClass,
}: iDetailListItemProps) => {
	return (
		<Box className={`detailItem ${detailListItemClass}`}>
			<Typography className="label">{title}</Typography>
			{renderValue ? (
				<Box className="value">{renderValue()}</Box>
			) : (
				<Typography className="value">{value || "N/A"}</Typography>
			)}
		</Box>
	);
};

export default CorporateEventDetailListItem;
